export default "__VITE_ASSET__CtKczvL6__"